import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d663484"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inline-flex flex-col items-end justify-center h-full" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Experience")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Skills")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Education")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Contact")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomRouterLink = _resolveComponent("CustomRouterLink")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["fixed top-0 bottom-0 left-0 right-0 invisible overflow-hidden text-center opacity-0 bg-accent-alpha", _ctx.isMenuOpen ? 'is-open' : ''])
  }, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", null, [
        _createVNode(_component_CustomRouterLink, {
          to: "#about",
          onClick: _ctx.handleMenuItemClick
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_CustomRouterLink, {
          to: "#work-experience",
          onClick: _ctx.handleMenuItemClick
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_CustomRouterLink, {
          to: "#skills",
          onClick: _ctx.handleMenuItemClick
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_CustomRouterLink, {
          to: "#education",
          onClick: _ctx.handleMenuItemClick
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_CustomRouterLink, {
          to: "#contact",
          onClick: _ctx.handleMenuItemClick
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ], 2))
}